module.exports = __webpack_public_path__ + "img/banner.2f189345.webp";